<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('branch') }}
    </h1>
    <div class="main__body">
      <div class="branch-functionally">
        <a @click="dragClick">Drag</a>
        <br>
        <a @click="relationClick">Relation</a>
        <br>
      </div>
      <div class="branches" v-on:mousemove="moveAt">
        <div ref="branches" class="branch-command" v-for="(item, key) in branch"
             v-bind:style="{
                position: item.x > 0 ? 'absolute' : positionByKey(key),
                left: item.x > 0 ? item.x : leftByKey(key),
                top: item.y > 0 ? item.y : topByKey(key),
            }"
             v-on:mousedown="myDrag(key, $event)"
             v-on:mouseup="myDragStop(key, $event)">
          {{ item.command }}
        </div>
      </div>
      <div class="relative-line"></div>
    </div>
  </div>
</template>

<style scoped>
.branch-command{
  cursor: pointer;
  background-color: #E6E6FA;
  width: 250px;
  padding: 10px 10px;
}
.relative-line{
  content: '';
  width: 10px;
  height: 10px;
  border-bottom: 2px solid blue;
}
</style>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'branch-bot',
  data: function(){
    return{
      branch: [
        {
          id: 1,
          name: 'start',
          command: '/start',
          position: 'relative',
          x: 0,
          y: 0,
        },
        {
          id: 2,
          name: 'stop',
          command: '/stop',
          position: 'relative',
          x: 0,
          y: 0,
        },
      ],
      reorderedList: [],
      draggableIndex: -1,
      dragLeft: 0,
      dragTop: 0,
      isDrag: false,
      isRelation: false,
      isLoading: false,
      fullPage: true
    }
  },
  methods: {
    myDrag: function(key, event) {
      if(this.isDrag){
        this.draggableIndex = key;
        this.branch[key].x = 0;
        this.branch[key].y = 0;
        this.reorderedList = this.branch;
        this.moveAt(event);
      }
    },
    moveAt: function(event){
      if(this.draggableIndex !== -1){
        this.dragLeft = event.pageX - 12;
        this.dragTop = event.pageY - 12;
      }
    },
    myDragStop: function(key, event) {
      if(this.isDrag) {
        this.draggableIndex = -1;
        this.dragLeft = 0;
        this.dragTop = 0;

        this.branch = Object.assign([], this.reorderedList, this.reorderedList);
        this.branch[key].position = 'absolute';
        this.branch[key].x = event.pageX;
        this.branch[key].y = event.pageY;
        return this.branch.join('→')
      }
    },
    isDragging: function(key) {
      return this.draggableIndex === key;
    },
    positionByKey: function(key) {
      return this.isDragging(key) ? 'absolute' : 'relative'
    },
    leftByKey: function(key) {
      return this.isDragging(key) ? this.dragLeft + 'px' : 0
    },
    topByKey: function(key) {
      return this.isDragging(key) ? this.dragTop + 'px' : 0
    },
    dragClick: function(){
      this.isDrag = true;
      this.isRelation = false;
    },
    relationClick: function(){
      this.isRelation = true;
      this.isDrag = false;
    },
  },
  components: {
    loading
  }
}
</script>